module.exports = __webpack_public_path__ + "images/spinner.dd88566680cbf35fabbf.gif";


//////////////////
// WEBPACK FOOTER
// ./resources/images/spinner.gif
// module id = +fkF
// module chunks = 1